const WORDS = ["Cartazes", "Eventos", "Artes Motion", "Estampas", "Capas de Livro", "Feed & Stories", "Logomarcas", "Branding", "Mídia Kit", "Pack Gospel"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 text-4xl md:text-6xl ${i % 2 ? "font-serif-i text-[#2DD4BF]" : "font-display font-semibold uppercase text-teal-50"}`}>{w}</span>
        <span className="text-2xl text-[#2DD4BF]">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-[#163D43] bg-[#071D1F] py-8" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
